<template>
  <v-layout column>
    <v-flex xs12>
      <basic-dialog :show="showSFR" max-width="750" @close="showSFR = false">
        <template v-slot:title>Quick Add</template>
        <sfr-list
          :start-date="startDate"
          :end-date="endDate"
          :destination-id="destination.id"
          :agent-id="agentId"
          :department="department"
          :adults="adults"
          :children="children"
          :infants="infants"
          @item-selected="onSFRItemSelected"
          @supplier-edit="onSupplierEdit"
          :supplier-type="addServiceSupplierType"
        ></sfr-list>
      </basic-dialog>
      <v-navigation-drawer
        v-if="false"
        v-model="drawer"
        style="z-index: 200; width: 500px"
        temporary
        :stateless="sfrStateless"
        fixed
        right
      >
        <sfr-list
          :start-date="startDate"
          :end-date="endDate"
          :destination-id="destination.id"
          :agent-id="agentId"
          :department="department"
          :adults="adults"
          :children="children"
          :infants="infants"
          @item-selected="onSFRItemSelected"
          @supplier-edit="onSupplierEdit"
        ></sfr-list>
      </v-navigation-drawer>
      <v-toolbar
        dense
        color="teal lighten-1"
        dark
        style="position: sticky; top: 55px; z-index: 100"
        class="gradient-bg"
      >
        <v-toolbar-title>
          <span v-if="reference != '' && false">
            {{ reference.split("/")[2] }}
            From: {{ startDate | formatDate }}, To:
            {{ endDate | formatDate }} ({{ bookingStatus }})
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn text @click="goTo(1)">Header</v-btn>
          <v-btn text @click="goTo(2)">Services</v-btn>

          <v-btn text @click="goTo(3)" v-if="isVisible('notes')"
            >Notes &amp; Contents</v-btn
          >

          <v-divider inset vertical></v-divider>
          <v-menu bottom left close-on-content-click>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                @click="onSave(true)"
                :disabled="loading || !validateFirstStep"
              >
                <v-list-item-title>{{ saveLabel }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="onSave(false)"
                :disabled="loading || !validateFirstStep"
              >
                <v-list-item-title>Save and Continue</v-list-item-title>
              </v-list-item>
              <confirmation-dialog @onConfirm="onSaveAsNew">
                <template slot="message"
                  >This will create new Ititnerary.</template
                >
                <template v-slot:options>
                  <v-switch
                    v-model="saveAsNewUpdateStatus"
                    label="Set Status as Quotation"
                    @change="onSaveAsNewUpdateStatusChange"
                  ></v-switch>
                </template>

                <v-list-item
                  v-if="id != ''"
                  style="cursor: pointer"
                  :disabled="loading || !validateFirstStep"
                >
                  <v-list-item-title>Save as New </v-list-item-title>
                </v-list-item>
              </confirmation-dialog>
              <v-list-item
                v-if="id != ''"
                @click="onCreateTemplate"
                :disabled="loading || !validateFirstStep"
              >
                <v-list-item-title>Save as Template </v-list-item-title>
              </v-list-item>

              <v-divider></v-divider>
              <v-list-item class="pt-3">
                <v-select
                  label="Show/Hide"
                  multiple
                  item-text="label"
                  item-value="key"
                  :outlined="outlinedInputs"
                  :items="optionalSections"
                  v-model="selectedSections"
                  @change="onVisibleSectionsChange"
                ></v-select>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            v-if="id != ''"
            text
            :disabled="loading || !validateFirstStep"
            @click="$router.push('/itinerary/' + id + '/details')"
          >
            <v-icon left>mdi-magnify</v-icon>Details
          </v-btn>
        </v-toolbar-items>
        <div class="pl-2" style="white-space: nowrap">
          <v-switch
            hide-details
            :disabled="id == '' || !hasAccessToLock"
            label="Locked"
            v-model="isLocked"
            @change="onLockToggle"
            :color="isLocked ? 'error' : 'primary'"
          ></v-switch>
        </div>
        <div class="pl-2" style="white-space: nowrap">
          <v-switch
            color="primary"
            hide-details
            label="One Page View"
            v-model="onePage"
            @change="onOnePageViewChange"
          ></v-switch>
        </div>
      </v-toolbar>
      <!-- <h1 class="headline">
        <span
          v-if="reference != ''"
        >{{reference}} - From: {{startDate | formatDate}}, To: {{ endDate | formatDate}}</span>
        <span v-else>Itinerary Builder</span>
      </h1>-->
      <v-container v-if="onePage" fluid pa-0>
        <v-expansion-panels multiple v-model="panels">
          <v-expansion-panel id="step1">
            <v-expansion-panel-header>
              <h5 class="headline pt-1 pb-1">Header</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <itinerary-builder-details
                :min-adults="minAdults"
                :min-children="minChildren"
                :min-infants="minInfants"
                :show-title="false"
                :adults="adults"
                :children="children"
                :infants="infants"
                :agent-id="agentId"
                :agent-name="agentName"
                :booked-by-id="bookedById"
                :booked-by-name="bookedByName"
                :department-name="department"
                :destination-id="destination.id"
                :internal-reference="internalReference"
                :client-reference="clientReference"
                :internal-status="internalStatus"
                :input-start-date="startDate"
                :input-end-date="endDate"
                @onDetailsChange="onDetailsChange"
                @agentChange="onAgentChange"
                @department-change="onDepartmentChange"
                @booked-by-change="onBookedByChange"
                @editAgent="onEditAgent"
                @newStartDate="onNewStartDate"
                @move="onMoveIt"
                @showPaxUpdater="onShowPaxUpdater"
                :brand="brand"
                :lead-source="leadSource"
                @startDateChange="onStartDateChange"
                @endDateChange="onEndDateChange"
              ></itinerary-builder-details>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline pt-1 pb-1">{{ paxTitle }}</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <participants-list
                :participants="participants"
                @add="onAddParticipant"
                @replace="onReplaceParticipant"
                @remove="onRemoveParticipant"
                @edit="onEditClient"
              ></participants-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="step2">
            <v-expansion-panel-header>
              <h5 class="headline pt-1 pb-0 mb-0">Services</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout px-3 v-if="showQuickAdd">
                <v-expansion-panels v-model="quickAddPanel">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >Service Quick Add</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <itinerary-builder-item-quick-add
                        :agent-id="agentId"
                        :start-date="startDate"
                        :destination="destination"
                        :adults="adults"
                        :children="children"
                        :infants="infants"
                        :duration="duration"
                        :department-name="department"
                        @onSelect="onServiceSelect"
                        @showAdhoc="showAdhocFromQuickAdd"
                        @supplier-edit="onSupplierEdit"
                      ></itinerary-builder-item-quick-add>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-layout>
              <itinerary-builder-items-list
                :items="items"
                :new-item="newItem"
                @newItem="onNewItem"
                @save-it="onSaveIt"
                @item-updated="itiItemUpdatedListener"
                @drag-and-drop-change="onDragAndDropChange"
                :header-props="headerProps"
                :participants="participants"
                @removeSelectedServices="onRemoveSelectedServices"
                @reorderSelectedServices="onReorderSelectedServices"
                @updateStatus="onUpdateStatus"
                @customPriceToggle="onCustomPriceToggle"
                @zeroSelectedServices="onZeroSelectedServices"
                @moveDays="onMoveDays"
                @update-exchange-rates="onUpdateExchangeRates"
                @onRecalculate="onRecalculate"
                @update-item="onUpdateItem"
                @showAdhoc="onShowAdhocFromGroupedView"
                @showAdhocFromEdit="onShowAdhocFromEdit"
                @showTemplate="onShowTemplateFromGroupedView"
                @supplier-edit="onSupplierEdit"
                @show-add-service="onShowAddService"
                @show-add-from-allocations="onShowAddFromAllocations"
                @show-add-charge="onShowAddCharge"
                @edit-charge="onEditCharge"
                @updatePax="onUpdatePax"
                @show-sfr="onShowSFR"
                @show-rs="onShowRS"
                @item-removed="onItemRemoved"
                @adjust-prices="onAdjustPrices"
                @refresh-prices="onRefreshPrices"
                :itinerary="itinerary"
                :basic-comps="basicComps"
                @show-iti-comps="onShowItiComps"
              ></itinerary-builder-items-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="step3" v-if="isVisible('notes')">
            <v-expansion-panel-header>
              <h5 class="headline pt-1 pb-1">Notes</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="pr-3 pl-3">
                <vue-editor v-model="notes"></vue-editor>
              </div>
              <h4 class="headline pt-1 pb-1">Contents</h4>
              <contents
                v-if="id"
                :owner-id="id"
                owner-name="ITINERARY"
                :filter="{ name_not: 'Itinerary Notes' }"
              ></contents>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <template v-if="editMode">
            <v-expansion-panel id="step4" v-if="isVisible('finances')">
              <v-expansion-panel-header>
                <h5 class="headline pt-1 pb-1">Finances</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <itinerary-details-finances-tabs
                  v-if="editMode"
                  :customFilters="{ itinerary_id: $route.params.id }"
                  :itinerary="itinerary"
                ></itinerary-details-finances-tabs>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel id="step5" v-if="isVisible('documents')">
              <v-expansion-panel-header>
                <h5 class="headline pt-1 pb-1">Documents</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <itinerary-details-documents-list
                  :itinerary="{ id }"
                ></itinerary-details-documents-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel id="step6" v-if="isVisible('scenarios')">
              <v-expansion-panel-header>
                <h5 class="headline pt-1 pb-1">Service Groups</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <service-groups
                  :items="items"
                  :itinerary-participants="participants"
                  v-model="serviceGroups"
                  @change="onServiceGroupsChange"
                ></service-groups>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>
      </v-container>

      <v-stepper v-else v-model="step" non-linear>
        <v-stepper-header v-if="false">
          <v-stepper-step :complete="step > 1" step="1" editable
            >Header</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2" :editable="editMode"
            >Services</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 3" step="3" :editable="editMode"
            >Notes &amp; Contents</v-stepper-step
          >
          <template v-if="editMode">
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="step > 4" :editable="editMode"
              >Finances</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="5" :complete="step > 5" :editable="editMode"
              >Documents</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="6" :complete="step > 6" :editable="editMode"
              >Scenarios</v-stepper-step
            >
          </template>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="py-0">
            <v-container fluid pa-0>
              <v-card class="mb-3 pa-3">
                <itinerary-builder-details
                  :adults="adults"
                  :children="children"
                  :infants="infants"
                  :agent-id="agentId"
                  :agent-name="agentName"
                  :booked-by-id="bookedById"
                  :booked-by-name="bookedByName"
                  :department-name="department"
                  :destination-id="destination.id"
                  :internal-reference="internalReference"
                  :client-reference="clientReference"
                  :internal-status="internalStatus"
                  :input-start-date="startDate"
                  :input-end-date="endDate"
                  @onDetailsChange="onDetailsChange($event)"
                  how-title="false"
                  @agentChange="onAgentChange"
                  @department-change="onDepartmentChange"
                  @booked-by-change="onBookedByChange"
                  @editAgent="onEditAgent"
                  :brand="brand"
                  @newStartDate="onNewStartDate"
                  @showPaxUpdater="onShowPaxUpdater"
                  @move="onMoveIt"
                ></itinerary-builder-details>
              </v-card>
              <v-expansion-panels v-model="paxPanel">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h5 class="headline pt-1 pb-1">{{ paxTitle }}</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <participants-list
                      :participants="participants"
                      @add="onAddParticipant"
                      @replace="onReplaceParticipant"
                      @remove="onRemoveParticipant"
                      @edit="onEditClient"
                    ></participants-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-btn
                color="primary"
                @click="firstStepContinue"
                :disabled="!validateFirstStep"
                text
              >
                Continue To Services
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-container>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-container py-0>
              <v-card flat v-if="showQuickAdd" class="px-5 pt-4">
                <itinerary-builder-item-quick-add
                  :agent-id="agentId"
                  :start-date="startDate"
                  :destination="destination"
                  :adults="adults"
                  :children="children"
                  :infants="infants"
                  :duration="duration"
                  :department-name="department"
                  @onSelect="onServiceSelect"
                  @showAdhoc="showAdhocFromQuickAdd"
                  @supplier-edit="onSupplierEdit"
                ></itinerary-builder-item-quick-add>
              </v-card>
            </v-container>
            <itinerary-builder-items-list
              v-if="step == 2"
              key="services-tab"
              :items="items"
              :new-item="newItem"
              @newItem="onNewItem($event)"
              @save-it="onSaveIt"
              @item-updated="itiItemUpdatedListener"
              @drag-and-drop-change="onDragAndDropChange"
              :header-props="headerProps"
              :participants="participants"
              @removeSelectedServices="onRemoveSelectedServices"
              @updateStatus="onUpdateStatus"
              @reorderSelectedServices="onReorderSelectedServices"
              @customPriceToggle="onCustomPriceToggle"
              @zeroSelectedServices="onZeroSelectedServices"
              @moveDays="onMoveDays"
              @update-exchange-rates="onUpdateExchangeRates"
              @onRecalculate="onRecalculate"
              @update-item="onUpdateItem($event)"
              @showAdhoc="onShowAdhocFromGroupedView"
              @showAdhocFromEdit="onShowAdhocFromEdit"
              @showTemplate="onShowTemplateFromGroupedView"
              @supplier-edit="onSupplierEdit"
              @show-add-service="onShowAddService"
              @show-add-from-allocations="onShowAddFromAllocations"
              @show-add-charge="onShowAddCharge"
              @edit-charge="onEditCharge"
              @updatePax="onUpdatePax"
              @show-sfr="onShowSFR"
              @show-rs="onShowRS"
              @item-removed="onItemRemoved"
              @adjust-prices="onAdjustPrices"
              @refresh-prices="onRefreshPrices"
              :basic-comps="basicComps"
              @show-iti-comps="onShowItiComps"
            ></itinerary-builder-items-list>
            <v-btn color="primary" @click.native="step = 3" text>
              Continue to Notes
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3" v-if="isVisible('notes')">
            <vue-editor v-model="notes"></vue-editor>

            <contents
              v-if="id"
              :owner-id="id"
              owner-name="ITINERARY"
              :filter="{ name_not: 'Itinerary Notes' }"
            ></contents>
          </v-stepper-content>
          <v-stepper-content step="4" v-if="isVisible('finances') && editMode">
            <itinerary-details-finances-tabs
              :customFilters="{ itinerary_id: $route.params.id }"
              :itinerary="itinerary"
            ></itinerary-details-finances-tabs>
          </v-stepper-content>
          <v-stepper-content step="5" v-if="isVisible('documents')">
            <itinerary-details-documents-list
              :itinerary="{ id }"
            ></itinerary-details-documents-list>
          </v-stepper-content>
          <v-stepper-content step="6" v-if="isVisible('scenarios')">
            <service-groups
              :items="items"
              :itinerary-participants="participants"
              v-model="serviceGroups"
              @change="onServiceGroupsChange"
            ></service-groups>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <template-settings-dialog
        :key="templateSettingsRefreshKey"
        :show="showTemplateSettingDialog"
        :selected-template="selectedTemplate"
        :date-range-start="startDate"
        :date-range-end="endDate"
        :max-adults="adults"
        :max-children="children"
        :max-infants="infants"
        :initial-start-date="showTemplateStartDate"
        :destination-id="destination.id"
        @onCancel="onTemplateAddCancel"
        @expandDateRange="onExpandDateTo"
        @addTemplate="onAddTemplate"
      ></template-settings-dialog>
      <add-adhoc-item
        :header-props="headerProps"
        :show="showAdhoc"
        :supplier-type="showAdhocSupplierType"
        :destination-id="showAdhocDestinationId"
        :initial-start-date="showAdhocStartDate"
        :initial-end-date="showAdhocEndDate"
        :supplier-name="showAdhocSupplierName"
        :supplier="showAdhocSupplier"
        :service="showAdhocService"
        :service-name="showAdhocServiceName"
        :edit-item="showAdhocEditItem"
        @close="onAdhocClose"
        @adhoc-add="onAdhocAddItem"
        @clear="onAdhocClear"
        :key="adhocRefreshKey"
      ></add-adhoc-item>
      <modal-supplier-edit
        v-model="editSupplier"
        :show="showSupplierEditor"
        @close="showSupplierEditor = false"
      ></modal-supplier-edit>
      <modal-client-edit
        v-model="editClient"
        :show="showClientEditor"
        @close="showClientEditor = false"
        @update-client="onUpdateClient"
      ></modal-client-edit>
      <modal-agent-edit
        v-model="editAgent"
        :show="showAgentEditor"
        @close="showAgentEditor = false"
        @update-agent="onUpdateAgent"
      ></modal-agent-edit>
      <add-service-dialog
        :show="showAddServiceDialog"
        @close="showAddServiceDialog = false"
        :header-props="headerProps"
        :supplier-type="addServiceSupplierType"
        @supplier-edit="onSupplierEdit"
        @onSelect="onServiceSelect"
        @showAdhoc="showAdhocFromQuickAdd"
      ></add-service-dialog>
      <add-from-allocations-dialog
        :header-props="headerProps"
        :show="showAddFromAllocations"
        @add="onAddFromAllocations"
        @close="showAddFromAllocations = false"
      ></add-from-allocations-dialog>
      <charge-edit-dialog
        v-model="editedCharge"
        :show="showChargeEditDialog"
        @close="showChargeEditDialog = false"
        @save="onChargeSave"
        :header="headerProps"
      ></charge-edit-dialog>
      <template-from-itinerary-dialog
        v-model="itiInput"
        :show="showCreateTemplate"
        @close="showCreateTemplate = false"
        @created="onTemplateCreated"
      ></template-from-itinerary-dialog>
      <pax-update-dialog
        :show="showPaxUpdater"
        skip-limit
        @close="showPaxUpdater = false"
        @update="onPaxUpdate"
        :headerProps="{ adults, children, infants }"
        :items="items"
      ></pax-update-dialog>
      <v-layout justify-center>
        <v-btn
          class="ma-2"
          v-if="sourceItinerary"
          @click="goToParent"
          color="secondary"
          outlined
        >
          <v-icon left small>mdi-format-list-bulleted-square</v-icon>
          PARENT: {{ parentReference }}
          <v-icon small right button>mdi-open-in-new</v-icon></v-btn
        >
        <v-btn
          v-if="id != ''"
          class="ma-2"
          :disabled="loading || !validateFirstStep"
          @click="$router.push('/itinerary/' + id + '/details')"
        >
          <v-icon left>mdi-magnify</v-icon>Details
        </v-btn>
        <v-btn
          v-if="id != ''"
          class="ma-2"
          :disabled="loading || !validateFirstStep"
          @click="onSupplierNotes"
        >
          <v-icon left>mdi-note-outline</v-icon>Supplier Notes</v-btn
        >
        <v-btn
          v-if="id != '' && allowRecalculate"
          class="ma-2"
          :disabled="loading || !validateFirstStep"
          @click="onRecalculate"
        >
          <v-icon left>mdi-refresh</v-icon>Recalculate
        </v-btn>
        <v-btn
          class="ma-2"
          id="saveAndContinueItineraryBtn"
          @click="onSave(false)"
          :disabled="loading || !validateFirstStep"
          >{{ saveLabel }} and Continue</v-btn
        >
        <confirmation-dialog @onConfirm="onSaveAsNew">
          <template slot="message">This will create new Ititnerary.</template>
          <template v-slot:options>
            <v-switch
              v-model="saveAsNewUpdateStatus"
              label="Set Status as Quotation"
              @change="onSaveAsNewUpdateStatusChange"
            ></v-switch>
          </template>

          <v-btn
            v-if="id != ''"
            class="ma-2"
            :disabled="loading || !validateFirstStep"
          >
            <v-icon left>mdi-content-copy</v-icon>
            Save as New</v-btn
          >
        </confirmation-dialog>
        <v-btn
          class="ma-2"
          color="primary"
          id="saveItineraryBtn"
          @click="onSave(true)"
          :disabled="loading || !validateFirstStep"
        >
          <v-icon>mdi-download</v-icon>
          {{ saveLabel }}
        </v-btn>
      </v-layout>
      <v-progress-linear
        :indeterminate="true"
        v-show="$apollo.loading || loading"
      ></v-progress-linear>
      <v-layout>
        <back-to-list-btn route="/itineraries"></back-to-list-btn>
      </v-layout>
    </v-flex>
    <confirmation-dialog
      :showDialog="showExpandDatesConfirmation"
      :callback="expandDatesCb"
      @onConfirm="showExpandDatesConfirmation = false"
      @onClose="showExpandDatesConfirmation = false"
    >
      <template slot="message"
        >This will expand your itinerary date range.</template
      >
    </confirmation-dialog>
    <itinerary-increments-dialog
      v-model="itinerary"
      :show="showIncrementsDialog"
      @close="showIncrementsDialog = false"
      @iti-updated="onItiUpdatedFromIncrements"
    />
    <itinerary-comps-dialog
      v-model="comps"
      :show="showItiCompsDialog"
      @close="showItiCompsDialog = false"
      :iti-items="items"
      @input="onCompsInput"
    />
    <supplier-iti-notes-dialog
      v-model="itinerary"
      :iti-items="items"
      @close="showSupplierNotes = false"
      :show="showSupplierNotes"
    />
    <rates-search-dialog
      :start-date="startDate"
      :end-date="endDate"
      :destination-id="destination.id"
      :agent-id="agentId"
      :department="department"
      :adults="adults"
      :children="children"
      :infants="infants"
      :show="showRS"
      @close="onRatesSearchClose"
      :header-props="headerProps"
      @add="onAddFromRS"
    />
    <v-flex xs12 v-if="debug">
      <code>
        {{ items }}
      </code>
    </v-flex>
  </v-layout>
</template>

<script>
import ItineraryBuilderDetails from "./ItineraryBuilderDetails";
import ItineraryBuilderItemQuickAdd from "./ItineraryBuilderItemQuickAdd";
import ItineraryBuilderItemsList from "./ItineraryBuilderItemsList";
import TemplateSettingsDialog from "../../templates/TemplateSettingsDialog";
import ItineraryDetailsFinancesTabs from "../ItineraryDetailsFinancesTabs";
import ItineraryDetailsDocumentsList from "../ItineraryDetailsDocumentsList";
import AddAdhocItem from "./tools/AddAdhocItem";
import BackToListBtn from "../../shared/BackToListBtn";
import ModalSupplierEdit from "../../shared/ModalSupplierEdit";
import ItineraryBuilderSettings from "./ItineraryBuilderSettings";
import ServiceGroups from "../scenarios/ServiceGroups";
import Contents from "../../shared/contents/Contents";
import ParticipantsList from "./ItineraryBuilderParticipantsList2";
import ModalClientEdit from "../../shared/ModalClientEdit";
import ModalAgentEdit from "../../shared/ModalAgentEdit";
import AddServiceDialog from "./ItineraryBuilderAddServiceDialog";
import AddFromAllocationsDialog from "./tools/AddFromAllocationsDialog";
import TemplateFromItineraryDialog from "./tools/TemplateFromItineraryDialog";
import SupplierCompsMixin from "./mixins/supplier-comps.js";

import { VueEditor } from "vue2-editor";
import {
  ITINERARY_CREATE_MUTATION,
  ITINERARY_RECORD_FOR_BUILDER,
  ITINERARY_UPDATE_MUTATION,
  ITINERARY_RECALCULATE_MUTATION,
  UPDATE_ITI_HEADER,
  PING_IT,
  CLOSE_IT,
} from "../../../../constants/graphql";
import gql from "graphql-tag";
import UnsavedChangesGuardMixin from "../../../../mixins/UnsavedChangesGuard";
import {
  getItiItemOrder,
  removeGQLTypename,
  extraDisplayQty,
} from "../../../../helpers/index";
import {
  toggleCustomPrices,
  setZeroSellPrices,
  reorderServices,
  updateItemsStatus,
  updateRangeByNewStartDate,
  updateItemsWithNewDateRange,
  updateItemsPax,
  updateExchangeRates,
  adjustPrices,
  refreshPrices,
} from "./tools/helpers";
import ChargeEditDialog from "./tools/ChargeEditDialog.vue";
import SfrList from "./sfr/SFRList";
import BasicDialog from "../../shared/BasicDialog";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import EventBus from "../../../../store/event-bus";
import PaxUpdateDialog from "./tools/PaxUpdateDialog.vue";
import ItineraryIncrementsDialog from "../ItineraryIncrementsDialog.vue";
import ItineraryCompsDialog from "./tools/ItineraryCompsDialog.vue";
import SupplierItiNotesDialog from "../supplier-notes/SupplierItiNotesDialog.vue";
import RatesSearchDialog from "./rates-search/RatesSearchDialog.vue";

var moment = require("moment");
var randomize = require("randomatic");

const CHECK_FOR_CLOSEOUTS = gql`
  query checkForCloseouts($input: CheckCloseoutInput!) {
    checkForCloseouts(input: $input) {
      supplierName
      serviceName
      hasCloseouts
      closeoutDates
    }
  }
`;

export default {
  name: "ItineraryBuilder",

  components: {
    ItineraryBuilderDetails,
    ItineraryBuilderItemQuickAdd,
    ItineraryBuilderItemsList,
    TemplateSettingsDialog,
    AddAdhocItem,
    ItineraryDetailsFinancesTabs,
    ItineraryDetailsDocumentsList,
    BackToListBtn,
    ModalSupplierEdit,
    ItineraryBuilderSettings,
    ServiceGroups,
    Contents,
    ParticipantsList,
    ModalClientEdit,
    AddServiceDialog,
    AddFromAllocationsDialog,
    ChargeEditDialog,
    SfrList,
    BasicDialog,
    ConfirmationDialog,
    ModalAgentEdit,
    TemplateFromItineraryDialog,
    PaxUpdateDialog,
    VueEditor,
    ItineraryIncrementsDialog,
    ItineraryCompsDialog,
    SupplierItiNotesDialog,
    RatesSearchDialog,
  },

  mixins: [UnsavedChangesGuardMixin, SupplierCompsMixin],

  data() {
    return {
      debug: false,
      drawer: true,
      sfrStateless: false,
      showSFR: false,
      showRS: false,
      forceRecalculate: false,
      addRecalcLog: true,
      onePage: this.$store.getters.localSettings("itBuilderOnePageView"),
      panels: [0, 1, 2],
      paxPanel: 0,
      quickAddPanel: 0,
      step: 1,
      adults: "2",
      children: "0",
      infants: "0",
      isLocked: false,
      createdAt: "",
      destination: {
        id:
          this.$store.getters.userConfig &&
          this.$store.getters.userConfig.destinationId
            ? this.$store.getters.userConfig.destinationId
            : "",
      },
      createdAt: "",
      startDate: "",
      endDate: "",
      editMode: false,
      agentId: this.$store.getters.itineraryAgentId,
      agentName: this.$store.getters.itineraryAgentName,
      bookedById: this.$store.getters.userId,
      bookedByName: "",
      department: this.$store.getters.itineraryDepartment,
      brand:
        this.$store.getters.userConfig && this.$store.getters.userConfig.brand
          ? this.$store.getters.userConfig.brand
          : "",
      leadSource: "",
      internalReference: "",
      internalStatus: "",
      clientReference: "",
      id: this.$route.params.id || "",
      reference: "",
      bookingStatus: "Quotation",
      loading: this.$route.params.id ? true : false,
      items: [],
      participants: [],
      serviceGroups: [],
      skipItLoad: true,
      newItem: undefined,
      //templates settings data
      selectedTemplate: {},
      showTemplateSettingDialog: false,
      templateSettingsRefreshKey: randomize("Aa0", 32),
      notes: "Initial Notes",
      showAdhoc: false,
      adhocRefreshKey: randomize("Aa0", 32),
      showAdhocSupplierType: "ACCOMMODATION",
      showAdhocDestinationId: "",
      showAdhocStartDate: "",
      showAdhocEndDate: "",
      showAdhocSupplierName: "",
      showAdhocServiceName: "",
      showAdhocSupplier: null,
      showAdhocService: null,
      showAdhocEditItem: null,
      showTemplateStartDate: "",
      showDetailsAfterSave: true,
      showIncrementsAfterSave: false,
      showSupplierEditor: false,
      showAgentEditor: false,
      editSupplier: null,
      showClientEditor: false,
      editClient: null,
      editAgent: null,
      showAddServiceDialog: false,
      showAddFromAllocations: false,
      editedCharge: null,
      showChargeEditDialog: false,
      showCreateTemplate: false,
      addServiceSupplierType: "ACCOMMODATION",
      addServiceStartDate: "",
      //select group data for grouped views
      selectedGroup: null,
      selectedSections: this.$store.getters.localSettings(
        "itBuilderOptionalSections",
        ["notes"]
      ),
      optionalSections: [
        { key: "notes", label: "Notes&Content" },
        /*{ key: "finances", label: "Finances" },
        { key: "documents", label: "Documents" },
        { key: "scenarios", label: "Service Groups" },*/
      ],
      save: false,
      showPaxUpdater: false,
      showExpandDatesConfirmation: false,
      expandDatesCb: null,
      pinger: null,
      showIncrementsDialog: false,
      pingInterval: 10000,
      logs: [],
      showSupplierNotes: false,
      copyFrom: null,
      priceCheck: true,
      saveAsNewUpdateStatus: this.$store.getters.localSettings(
        "saveAsNewUpdateStatus",
        false
      ),
      sourceItinerary: null,
      templateItemsToCheck: null,
      checkForCloseoutsResultCallback: null,
    };
  },

  methods: {
    setDefaultDepartment() {
      if (this.$store.getters.userConfig.department != "" && !this.id) {
        this.department = this.$store.getters.userConfig.department;
        this.$store.dispatch("setItineraryDepartment", this.department);
      }
    },
    goToParent() {
      window.open(`/itinerary/${this.sourceItinerary.id}/details`, "_blank");
    },
    onSaveAsNewUpdateStatusChange(payload) {
      console.log("save as new update status change", payload);
      this.$store.dispatch("updateLocalSettings", {
        saveAsNewUpdateStatus: payload,
      });
    },
    itemsOutsideDateRange() {
      return (
        this.items.filter(
          (i) =>
            moment(i.startDate)
              .startOf("day")
              .isBefore(moment(this.startDate).startOf("day")) ||
            moment(i.endDate)
              .startOf("day")
              .isAfter(moment(this.endDate).startOf("day"))
        ).length > 0
      );
    },
    closeIt() {
      const fingerprint = {
        userAgent: window.navigator.userAgent,
        tabId: window.sessionStorage.getItem("tabId"),
      };
      this.$apollo
        .mutate({
          mutation: CLOSE_IT,
          variables: { id: this.id, fingerprint: JSON.stringify(fingerprint) },
          fetchPolicy: "no-cache",
        })
        .then((resp) => {
          //console.log("iti closed", resp);
        })
        .catch((err) => console.log("close err:", err));
    },
    onRatesSearchClose() {
      this.showRS = false;
      EventBus.$emit("rs-clear");
    },
    onSupplierNotes() {
      //console.log("showing supplier notes");
      this.showSupplierNotes = true;
    },
    itiItemUpdatedListener(item) {
      this.lastAddedSupplierId = item.supplierId;
      if (item.linkedServices && item.linkedServices.length > 0) {
        for (let linkedService of item.linkedServices) {
          const existing = this.items.find(
            (i) => i.serviceId == linkedService.serviceId
          );
          if (existing) {
            Object.assign(existing, {
              orderNo: item.orderNo,
              ...linkedService,
            });
          } else {
            this.items.push({
              orderNo: item.orderNo,
              ...linkedService,
            });
          }
        }
      }
      this.checkForApplicableComps();
    },
    addLog(marker, payload = undefined) {
      let message = "";
      if (marker == "AGENT_CH") {
        message = `Itinerary Agent Changed to ${payload.name}`;
      } else if (marker == "DPMNT_CH") {
        message = `Itinerary Department Changed to ${payload}`;
      } else if (marker == "DATES_CH") {
        message = `Itinerary Dates Changed to ${this.$options.filters.formatDate(
          this.startDate
        )} - ${this.$options.filters.formatDate(this.endDate)}`;
      } else if (marker == "CALC") {
        message = "Itinerary Recalculated";
      }
      this.logs = [
        ...this.logs.filter((l) => l.marker != marker),
        { message, marker, itineraryId: this.id },
      ];
    },

    onItiUpdatedFromIncrements() {
      this.showIncrementsDialog = false;
      this.$router.push("/itinerary/" + this.id + "/details");
    },
    updateToZeroPrices() {
      const total = this.items
        .filter(
          (item) => item.isIncluded && item.serviceType != "MANDATORY_CHARGES"
        )
        .reduce(
          (t, item) =>
            Number(t) +
            Number(item.price) +
            (item.extras
              ? item.extras.reduce(
                  (te, e) => Number(te) + Number(e.totalSell),
                  0
                )
              : 0),
          0
        );
      const toZeroCharge = this.items.find(
        (item) => item.serviceName == "TO ZERO PRICES"
      );
      toZeroCharge.pricing.adultSell = -1 * total;
      const editedIndex = this.items.findIndex((i) => i.id == toZeroCharge.id);
      Object.assign(this.items[editedIndex], {
        ...toZeroCharge,
        price: -1 * total,
      });
      this.showIncrementsAfterSave = true;
    },
    onItemRemoved() {
      if (this.fromIncrement) {
        this.showIncrementsAfterSave = true;
      }
      this.checkForApplicableComps();
    },
    onAdjustPrices(payload) {
      this.items = adjustPrices(this.items)(payload);
    },
    onRefreshPrices(payload) {
      this.items = refreshPrices(this.items)(payload);
      this.recalculate();
    },
    onLockToggle() {
      this.onSave(false);
      /*
      this.$apollo
        .mutate({
          mutation: UPDATE_ITI_HEADER,
          variables: {
            id: this.id,
            input: { isLocked: this.isLocked },
          },
        })
        .then(({ data }) => {
          console.log(data);
        })
        .catch((err) => console.log(err));
        */
    },
    onShowSFR(payload) {
      //console.log("show sfr payload", payload);
      if (payload.fieldName && payload.fieldName == "serviceType") {
        this.addServiceSupplierType = payload.label;
      } else if (payload.fieldName && payload.fieldName == "startDate") {
        this.addServiceStartDate = payload.label;
      }

      this.showSFR = true;
    },
    onShowRS(payload) {
      this.showRS = true;
    },
    onPaxUpdate(payload) {
      this.showPaxUpdater = false;
      this.items = updateItemsPax(this.items)({
        payload,
        selected: [...this.items],
      });
      this.adults = payload.totals.adults.toString();
      this.children = payload.totals.children.toString();
      this.infants = payload.totals.infants.toString();
      this.checkForApplicableComps();
      this.addRecalcLog = false;
      this.recalculate();
    },
    onShowPaxUpdater() {
      this.showPaxUpdater = true;
    },
    onTemplateCreated(payload) {
      this.showCreateTemplate = false;
    },
    onCreateTemplate() {
      this.showCreateTemplate = true;
    },
    onUpdatePax(payload) {
      this.items = updateItemsPax(this.items)(payload);
      this.checkForApplicableComps();
      this.recalculate();
    },
    onRecalculate() {
      this.forceRecalculate = true;
      this.recalculate(true);
    },
    onVisibleSectionsChange() {
      this.$store.dispatch("updateLocalSettings", {
        itBuilderOptionalSections: [...this.selectedSections],
      });
    },
    isVisible(key) {
      return this.selectedSections.indexOf(key) > -1;
    },
    onShowAddFromAllocations() {
      this.showAddFromAllocations = true;
    },
    onShowAddCharge() {
      const confirmCharge = this.$store.getters.hasAccessTo(
        "itineraries:confirm_charge"
      );
      this.editedCharge = {
        serviceName: "New charge",
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        qty: 1,
        statusName: confirmCharge ? "Confirmed" : "Quotation",
        statusId: confirmCharge
          ? "U2VydmljZVN0YXR1cy0z"
          : "U2VydmljZVN0YXR1cy0x",
      };
      this.showChargeEditDialog = true;
    },
    onEditCharge(payload) {
      this.editedCharge = { ...payload };
      this.showChargeEditDialog = true;
    },
    onChargeSave(payload) {
      const edited = {
        ...payload,
      };
      const existing = this.items.find((item) => item.id == payload.id);
      if (existing) {
        const itemIndex = this.items.indexOf(existing);
        const editedItem = { ...this.items[itemIndex], ...payload };
        this.items.splice(itemIndex, 1, editedItem);
      } else {
        this.items.push(edited);
      }
      this.showChargeEditDialog = false;
    },
    onAddFromAllocations(items) {
      this.showAddFromAllocations = false;
      this.items = [
        ...this.items,
        ...items.map((item) => ({
          ...item,
          orderNo: getItiItemOrder(this.headerProps)(this.items)(item),
        })),
      ];
      this.addRecalcLog = false;
      this.recalculate();
    },
    onAddFromRS(item) {
      const newItem = {
        ...item,
        orderNo: getItiItemOrder(this.headerProps)(this.items)(item),
      };
      this.items.push(newItem);
      if (newItem.linkedServices && newItem.linkedServices.length > 0) {
        for (let linkedService of newItem.linkedServices) {
          this.items.push({ ...linkedService, orderNo: newItem.orderNo });
        }
      }
      this.checkForApplicableComps();
    },
    onShowAddService(payload) {
      this.selectedGroup = { ...payload };
      if (payload.fieldName && payload.fieldName == "serviceType") {
        this.addServiceSupplierType = payload.label;
      }
      this.showAddServiceDialog = true;
    },
    onSupplierEdit(payload) {
      this.editSupplier = { ...payload };
      this.showSupplierEditor = true;
    },
    onEditClient(payload) {
      this.editClient = { ...payload };
      this.showClientEditor = true;
    },
    onEditAgent(payload) {
      this.editAgent = { ...payload };
      this.showAgentEditor = true;
    },
    onUpdateAgent(payload) {
      //console.log("Agent updated");
    },
    onUpdateClient(payload) {
      const updated = this.participants.find((p) => p.id == payload.id);
      if (updated) {
        updated.title = payload.title;
        updated.name = payload.name;
        updated.surname = payload.surname;
        updated.email = payload.email;
        updated.telephone = payload.telephone;
        updated.mobile = payload.mobile;
        updated.state = payload.state;
        updated.city = payload.city;
        updated.postCode = payload.postCode;

        updated.code = payload.code;
        updated.notes = payload.notes;
        updated.birthDate = payload.birthDate;
        updated.address = payload.address;
        updated.nationality = payload.nationality;
        updated.language = payload.language;
        updated.clientTypeId = payload.clientTypeId;
        updated.clientStatusId = payload.clientStatusId;
      }
    },
    goTo(step) {
      this.onePage
        ? this.$vuetify.goTo(`#step${step}`, {
            duration: 300,
            offset: 0,
          })
        : (this.step = step);
    },
    onOnePageViewChange($event) {
      this.$store.dispatch("updateLocalSettings", {
        itBuilderOnePageView: $event,
      });
    },
    onAddParticipant(payload) {
      if (this.maxParticipants > this.participants.length) {
        const participant = payload
          ? { ...payload }
          : {
              title: "Mr.",
              name: "",
              surname: "",
              email: "",
              mobile: "",
            };
        this.participants.push(participant);
      } else {
        alert(`Max number of participants is ${this.maxParticipants}`);
      }
      if (this.save) {
        this.onSave(this.showDetailsAfterSave);
      }
    },
    onReplaceParticipant(payload) {
      if (payload.index > -1) {
        Object.assign(this.participants[payload.index], { ...payload.new });
      }
    },
    onRemoveParticipant($payload) {
      this.participants.splice($payload, 1);
    },
    onServiceSelect(payload) {
      if (payload.__typename == "Template") {
        this.selectedTemplate = payload;
        this.templateSettingsRefreshKey = randomize("Aa0", 32);
        this.showTemplateSettingDialog = true;
      } else {
        //override id to be unique for each stay even same service
        payload.id = randomize("Aa0", 32);
        //update dates based on selected "grouped" view
        if (this.selectedGroup) {
          if (this.selectedGroup.fieldName == "startDate") {
            //day by context
            payload.startDate = this.selectedGroup.label; //probably not the best name;]
          }
          //reset last group context
          this.selectedGroup = null;
        }

        //set end date for non accommodation services
        if (payload.serviceType != "ACCOMMODATION") {
          payload.endDate = payload.startDate;
        }

        this.newItem = Object.assign({}, { ...payload });
      }
    },
    onNewItem(item) {
      this.items.push(item);
      if (item.linkedServices && item.linkedServices.length > 0) {
        for (let linkedService of item.linkedServices) {
          this.items.push({ ...linkedService, orderNo: item.orderNo });
        }
      }
      this.sfrStateless = false;
      if (this.fromIncrement) {
        this.updateToZeroPrices();
      }
      this.lastAddedSupplierId = item.supplierId;
      this.checkForApplicableComps();
    },

    onAdhocClose() {
      this.showAdhocSupplierName = "";
      this.showAdhocServiceName = "";
      this.showAdhocStartDate = "";
      this.showAdhocEndDate = "";
      this.showAdhocSupplier = null;
      this.showAdhocService = null;
      this.showAdhoc = false;
      this.showAdhocEditItem = null;
    },
    onAdhocClear() {
      //console.log("onAdhocClear");
      this.showAdhocSupplierName = "";
      this.showAdhocServiceName = "";
      this.showAdhocSupplier = null;
      this.showAdhocService = null;
    },
    onAdhocAddItem(payload) {
      const adhocItem = { ...payload.data };
      // adhocItem.orderNo = getItiItemOrder(this.headerProps)(this.items)(
      //   adhocItem
      // );
      const existing = this.items.find((item) => item.id == adhocItem.id);
      if (existing) {
        const itemIndex = this.items.indexOf(existing);
        const editedItem = { ...this.items[itemIndex], ...adhocItem };
        //new id to update xml
        editedItem.id = randomize("Aa0", 32);
        this.items.splice(itemIndex, 1, editedItem);

        // Handle linked services for edited items
        if (editedItem.linkedServices && editedItem.linkedServices.length > 0) {
          for (let linkedService of editedItem.linkedServices) {
            const existingLinked = this.items.find(
              (i) =>
                i.serviceId == linkedService.serviceId &&
                i.parentId == editedItem.id
            );
            if (existingLinked) {
              const linkedIndex = this.items.indexOf(existingLinked);
              this.items.splice(linkedIndex, 1, {
                ...linkedService,
                orderNo: editedItem.orderNo,
              });
            } else {
              this.items.push({
                ...linkedService,
                orderNo: editedItem.orderNo,
              });
            }
          }
        }
      } else {
        adhocItem.orderNo = getItiItemOrder(this.headerProps)(this.items)(
          adhocItem
        );
        this.items.push(adhocItem);

        // Handle linked services for new items
        if (adhocItem.linkedServices && adhocItem.linkedServices.length > 0) {
          for (let linkedService of adhocItem.linkedServices) {
            this.items.push({ ...linkedService, orderNo: adhocItem.orderNo });
          }
        }
      }
      if (payload.action == "close") {
        this.showAdhocSupplierName = "";
        this.showAdhocServiceName = "";
        this.showAdhocSupplier = null;
        this.showAdhocService = null;
        this.showAdhoc = false;
        this.showAdhocEditItem = null;
      }
      //console.log("adhocItem", adhocItem);
      this.lastAddedSupplierId = adhocItem.supplierId;
      this.checkForApplicableComps();
    },
    onUpdateItem($payload) {
      //console.log("update item", $payload);
    },
    onDetailsChange($payload) {
      //this.adults = $payload.adults
      for (let field in $payload) {
        this[field] = $payload[field];
      }
    },
    onBookedByChange(payload) {
      if (this.$store.getters.hasAccessTo("itineraries:lock_department")) {
        return;
      }
      if (
        (this.$store.getters.userConfig.ownerId == this.agentId ||
          this.$store.getters.itineraryAgentDepartment == "") &&
        payload.department
      ) {
        this.department = payload.department;
        this.$store.dispatch("setItineraryDepartment", this.department);
        this.recalculate();
      }
    },
    onAgentChange(payload) {
      this.agentId = payload.id;
      this.agentName = payload.name;
      this.$store.dispatch("setItineraryAgent", payload.id);
      this.$store.dispatch("setItineraryAgentName", payload.name);

      //console.log("onAgentChange", payload);
      if (payload.financeSettings && payload.financeSettings.currencyCode) {
        this.$store.dispatch(
          "setItineraryAgentCurrency",
          payload.financeSettings.currencyCode
        );
      }
      if (
        !payload.isOwner &&
        payload.department.toString() != "" &&
        !this.$store.getters.hasAccessTo("itineraries:lock_department")
      ) {
        this.department = payload.department;
      }
      this.$store.dispatch("setItineraryDepartment", this.department);
      console.log("onAgentChange", payload);
      this.addLog("AGENT_CH", payload);
      this.recalculate();
    },
    onDepartmentChange(payload) {
      this.addLog("DPMNT_CH", payload);
      this.recalculate();
    },
    firstStepContinue() {
      //edit for services and participants
      //this.editMode = true;
      this.step = 2;
    },
    checkCurrentItemsForCloseouts(items = null, resultCallback = null) {
      if (resultCallback) {
        this.checkForCloseoutsResultCallback = resultCallback;
      }
      const source = items != null ? items : this.items;
      this.templateItemsToCheck = source.map((item) => ({
        serviceId: item.serviceId,
        ...(item.serviceName != null && { serviceName: item.serviceName }),
        startDate: item.startDate,
        endDate: item.endDate,
        qty: item.qty,
        adults: item.adults,
        children: item.children,
        infants: item.infants,
      }));
    },
    onSaveAsNew() {
      this.checkCurrentItemsForCloseouts(null, () => {
        this.saveAsNew();
      });
    },
    saveAsNew() {
      this.checkForCloseoutsResultCallback = null;
      this.copyFrom = this.id;
      this.id = "";
      //clear remarks
      this.items = this.items.map((item) => {
        //delete item.remarks; // ??? #10897 - should we keep remarks?
        if (this.saveAsNewUpdateStatus) {
          item.status = "Quotation";
          item.statusId = "U2VydmljZVN0YXR1cy0x";
          item.extras = item.extras.map((e) => {
            e.status = "Quotation";
            e.statusId = "U2VydmljZVN0YXR1cy0x";
            return e;
          });
        }
        return { ...item };
      });
      this.priceCheck = true;
      this.saveItinerary();
    },
    onSaveIt() {
      this.onSave(false);
    },
    onSave(showDetails) {
      this.showDetailsAfterSave = showDetails;
      if (this.participants.length == 0) {
        EventBus.$emit("showAddPaxDialog");
        this.save = true;
      } else if (this.itemsOutsideDateRange()) {
        alert(
          "Please check your dates. You have services outside the itinerary date range."
        );
      } else {
        if (this.id == "") {
          //create
          this.saveItinerary();
        } else {
          // if (this.fromIncrement) {
          //   const { initState, ...currentState } = this.$data;
          //   console.log(this.initState, JSON.stringify(currentState));
          //   if (this.initState != JSON.stringify(currentState)) {
          //     this.showIncrementsAfterSave = true;
          //   }
          // }
          this.saveItinerary(true);
        }
      }
    },
    getItiInput() {
      return {
        isLocked: this.isLocked,
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        startDate: this.startDate,
        endDate: this.endDate,
        department: this.department,
        internalReference: this.internalReference,
        internalStatus: this.internalStatus,
        clientReference: this.clientReference,
        destinationId: this.destination.id,
        agentId: this.agentId,
        items: this.items.map(this.toItineraryInputItem),
        participants: this.participants.map(this.toItineraryParticipantInput),
        notes: this.notes,
        bookedById: this.bookedById,
        brand: this.brand,
        leadSource: this.leadSource,
        serviceGroups: this.serviceGroups,
        logs: this.logs,
        comps: this.comps.map(this.compToItiInput),
        copyFromId: this.copyFrom ? this.copyFrom : undefined,
        priceCheck: this.priceCheck,
      };
    },
    recalculate(force = false) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ITINERARY_RECALCULATE_MUTATION,
          variables: {
            force,
            id: this.id,
            ...this.getItiInput(),
            priceCheck: this.priceCheck,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          ///update items
          this.items = res.data.recalculateItinerary.items.edges.map(
            this.fromItineryItem
          );
          this.loading = false;
          if (this.fromIncrement) {
            this.updateToZeroPrices();
          }
          if (this.addRecalcLog) {
            this.addLog("CALC");
          }
          this.addRecalcLog = true;
          this.priceCheck = true;
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
          this.loading = false;
        });
    },
    saveItinerary(update = false) {
      this.loading = true;
      let mutation = ITINERARY_CREATE_MUTATION;
      let variables = this.getItiInput();
      if (update) {
        mutation = ITINERARY_UPDATE_MUTATION;
        variables.id = this.id;
        variables.recalculate = this.forceRecalculate;
      }
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: variables,
        })
        .then(this.saveItineraryHandler, this.saveItineraryErrorHandler);
    },
    saveItineraryHandler(result) {
      this.routeGuard = false;
      this.copyFrom = null;
      clearInterval(this.pinger);
      if (result.data.hasOwnProperty("createItinerary")) {
        const itData = result.data.createItinerary;
        this.reference = itData.reference;
        this.id = itData.id;
        if (this.showDetailsAfterSave) {
          this.$router.push("/itinerary/" + this.id + "/details");
        }
      } else if (result.data.hasOwnProperty("updateItinerary")) {
        if (this.showIncrementsAfterSave) {
          this.skipItLoad = false;
          this.showIncrementsDialog = true;
        } else if (this.showDetailsAfterSave) {
          this.$router.push("/itinerary/" + this.id + "/details");
        } else {
          this.skipItLoad = false;
          this.showDetailsAfterSave = true;
        }

        this.$store.dispatch("showAppSnackbar", {
          msg: result.data.updateItinerary.message,
          large: true,
        });
      }
      this.loading = false;
      this.logs = [];
    },
    saveItineraryErrorHandler(result) {
      //show some error popup with description
      //console.log(result);
      const errorMsg = result.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
      this.loading = false;
    },
    toItineraryParticipantInput(item) {
      return {
        id: item.id ? item.id : undefined,
        title: item.title,
        name: item.name,
        surname: item.surname,
        email: item.email,
        mobile: item.mobile,
        telephone: item.telephone,
        code: item.code,
        language: item.language,
        nationality: item.nationality,
        notes: item.notes,
        rooms: item.rooms || [],
        groupLabel: item.groupLabel || "",
      };
    },
    toItineraryInputItem(item) {
      let ratePlan = typeof item.ratePlan == "undefined" ? "" : item.ratePlan;
      if (
        item.pricing &&
        item.pricing.ratePlan != "" &&
        typeof item.pricing.ratePlan != "undefined"
      ) {
        ratePlan = item.pricing.ratePlan;
      }
      const input = {
        id: item.id,
        serviceId: item.serviceId,
        startDate: item.startDate,
        endDate: item.endDate,
        qty: parseInt(item.qty),
        adults: parseInt(item.adults),
        children: parseInt(item.children),
        infants: parseInt(item.infants),
        statusId: item.statusId,
        orderNo: parseInt(item.orderNo),
        isOptional: item.isOptional,
        isIncluded: item.isIncluded,
        isHidden: item.isHidden,
        isMandatory: item.isMandatory,
        includeCommission: item.includeCommission,
        tags: item.tags,
        ratePlan: ratePlan ? ratePlan : "",
        taxCode: item.taxCode,
        allocationUID: item.allocation ? item.allocation : "",
        businessModel: item.businessModel ? item.businessModel : "BM1",
        boardBasis: item.boardBasis ? item.boardBasis : "",
        supplierComp: item.supplierComp ? Number(item.supplierComp) : 0,
        passComp: item.passComp ? Number(item.passComp) : 0,
        serviceType: item.serviceType,
        parentId: item.parentId,
        supplierCommission: item.supplierCommission
          ? item.supplierCommission
          : 0,
        yearShift:
          Number(item.yearShift) > 0
            ? Number(item.yearShift) * -1
            : Number(item.yearShift),
        isHistoricalRate: item.isHistoricalRate,
      };
      if (input.serviceType == "MANDATORY_CHARGES") {
        input.serviceName = item.serviceName;
      }
      if (item.hasOwnProperty("source")) {
        //add souce section for rezgraph
        if (item.source.name != "GTWEB") {
          input.source = Object.assign({}, item.source);
        }
      }
      //
      input.customPricing = item.customPricing;
      if (item.pricing) {
        //remove pricingDaysForNow
        //console.log(item.pricing);

        const { pricingDays, ...pricingNode } = item.pricing;

        const pricing = pricingDays ? pricingNode : { ...item.pricing };
        // and few other fields
        for (const f of [
          "itemBased",
          "dayBased",
          "extras",
          "discount",
          "discountDescription",
          "discountInfo",
        ]) {
          if (pricing.hasOwnProperty(f)) {
            delete pricing[f];
          }
        }
        if (pricing.hasOwnProperty("ratePlan") && pricing.ratePlan == null) {
          pricing.ratePlan = "";
        }
        input.pricing = Object.assign({}, pricing);
      }
      if (item.extras) {
        input.extras = item.extras.map((e) => {
          let pricing = e.pricing ? { ...e.pricing } : undefined;
          if (e.customPricing && !pricing) {
            pricing = {
              cost: e.cost,
              sell: e.sell,
              currency: e.currencyBuy,
              currencyExchangeRate: e.currencyBuyExchangeRate,
              currencySellExchangeRate: e.currencySellExchangeRate,
              rateTypeCode: e.rateTypeCode,
            };
          }
          let extraQty = e.qty;
          if (e.rateBase == "P") {
            if (e.isChildOnly) {
              extraQty = Number(e.children);
            } else if (e.isInfantOnly) {
              extraQty = Number(e.infants);
            } else {
              extraQty = Number(e.adults);
            }
          }
          return {
            id: e.id,
            uid: e.uid ? e.uid : undefined,
            qty: extraQty,
            startDate: e.startDate,
            endDate: e.endDate,
            pricing,
            isHidden: e.isHidden,
            isOptional: e.isOptional,
            isIncluded: e.isIncluded,
            statusId: e.statusId,
            includeCommission: e.commission || e.includeCommission,
            remarks: { ...e.remarks },
            orderNo: e.orderNo,
          };
        });
      }
      if (item.hasOwnProperty("remarks")) {
        const {
          pickupPoint,
          dropoffPoint,
          pickupTime,
          dropoffTime,
          timeFrom,
          agentNotes,
          supplierNotes,
          voucherNotes,
          internalNotes,
          confirmationNo,
          flightNo,
          roomNumbers,
        } = item.remarks;
        input.remarks = {
          pickupPoint,
          dropoffPoint,
          pickupTime,
          dropoffTime,
          timeFrom,
          agentNotes,
          supplierNotes,
          voucherNotes,
          internalNotes,
          confirmationNo,
          flightNo,
          roomNumbers,
        };
        //http://tracker.globetrack.ie/issues/5781
        if (
          input.remarks.dropoffPoint &&
          input.remarks.dropoffPoint.hasOwnProperty("name")
        ) {
          input.remarks.dropoffPoint = input.remarks.dropoffPoint.name;
        }
        if (
          input.remarks.pickupPoint &&
          input.remarks.pickupPoint.hasOwnProperty("name")
        ) {
          input.remarks.pickupPoint = input.remarks.pickupPoint.name;
        }
      }
      return input;
    },
    getCustomPricing(input) {
      return {
        currencyBuy: "EUR",
      };
    },
    fromItineraryParticipant(node) {
      let p = Object.assign({}, node.node);
      if (p.client) {
        p.id = p.client.id;
      }
      return p;
    },
    fromItineryItem(node) {
      const item = node.node;
      const { __typename, ...source } = item.source;
      const pricing = { ...item.pricing };
      const remarks = { ...item.remarks };
      const extras = item.extras.map((e) => ({
        id: e.id,
        uid: e.uid, //https://tracker.globetrack.ie/issues/8740 wtfff? why uid was not present in those items?
        //id: e.id.split("_")[1],
        name: e.name,
        startDate: e.startDate,
        endDate: e.endDate,
        qty: e.qty, //extraDisplayQty(e),
        totalBuy: e.totalBuy,
        totalSell: e.totalSell,
        currencySell: e.currencySell,
        currencyBuy: e.currencyBuy,
        isChildOnly: e.isChildOnly,
        isInfantOnly: e.isInfantOnly,
        isMandatory: e.isMandatory,
        includeCommission: e.includeCommission,
        rateBase: e.rateBase,
        adults: e.adults,
        children: e.children,
        infants: e.infants,
        cost: e.cost,
        sell: e.sell,
        rateTypeCode: e.rateTypeCode,
        percentPrice: e.percentPrice,
        customPricing: e.customPricing,
        currencySellExchangeRate: e.currencySellExchangeRate,
        currencyBuyExchangeRate: e.currencyBuyExchangeRate,
        isHidden: e.isHidden,
        isOptional: e.isOptional,
        isIncluded: e.isIncluded,
        status: e.status,
        statusId: e.statusId,
        totalCostInBase: e.totalCostInBase,
        totalSellInBase: e.totalSellInBase,
        discount: e.discount,
        discountCost: e.discountCost,
        discountSell: e.discountSell,
        circuitDiscountCost: e.circuitDiscountCost,
        circuitDiscountSell: e.circuitDiscountSell,
        toms: e.toms,
        remarks: removeGQLTypename(e.remarks),
        orderNo: e.orderNo,
      }));
      delete pricing.__typename;
      pricing.logs = pricing.logs ? pricing.logs.map(removeGQLTypename) : [];
      return {
        id: item.id,
        serviceId: item.service ? item.service.id : "",
        supplierId: item.supplier ? item.supplier.id : "",
        serviceName: item.serviceName,
        serviceAltName: item.service ? item.service.altName : "",
        stdOccupancy: item.service ? Number(item.service.stdOccupancy) : 1,
        supplierName: item.supplierName,
        supplierDestination: item.supplierDestination,
        headOffice:
          item.supplier && item.supplier.headOffice
            ? item.supplier.headOffice.name
            : "",
        startDate: item.startDate,
        endDate: item.endDate,
        lastUpdated: item.lastUpdated,
        price: item.totalPrice,
        totalCostInBase: item.totalCostInBase,
        totalSellInBase: item.totalSellInBase,
        margin: item.margin,
        markup: item.markup,
        status: item.status,
        statusId: item.statusId,
        adults: item.pax.adults,
        children: item.pax.children,
        infants: item.pax.infants,
        qty: item.qty,
        rateTypeCode: item.rateTypeCode,
        taxCode: item.taxCode ? item.taxCode : "",
        ratePlan: item.ratePlan ? item.ratePlan : "",
        serviceType: item.serviceTypeName,
        orderNo: item.orderNo,
        isIncluded: item.isIncluded,
        isOptional: item.isOptional,
        isHidden: item.isHidden,
        isMandatory: item.isMandatory,
        includeCommission: item.includeCommission,
        tags: item.tags,
        hasApprovedPurchaseInvoice: item.hasApprovedPurchaseInvoice,
        hasPurchaseInvoice: item.hasPurchaseInvoice,
        allocation:
          pricing.pricingDays && pricing.pricingDays[0]
            ? pricing.pricingDays[0].allocation
            : "",
        selected: false,
        source: {
          id: source.sourceId,
          rsResultServiceId: source.rsResultServiceId,
          name: source.name,
          confirmationRef: source.confirmationRef,
        },
        customPricing: item.customPricing,
        businessModel: item.businessModel,
        businessModelName: item.businessModelName,
        supplierCommission: item.supplierCommission,
        supplierCommissionValue: item.supplierCommissionValue,
        commission: item.commission,
        supplierComp: item.supplierComp ? item.supplierComp : 0,
        passComp: item.passComp ? item.passComp : 0,
        parentId: item.parentId,
        toms: item.toms,
        yearShift:
          Number(item.yearShift) > 0
            ? Number(item.yearShift) * -1
            : Number(item.yearShift),
        boardBasis: item.boardBasis,
        isHistoricalRate: item.isHistoricalRate,
        pricing,
        extras,
        remarks,
      };
    },
    setupFromData(data) {
      if (data != undefined) {
        this.paxPanel = [];
        this.panels = [0, 2];
        this.adults = data.itinerary.pax.adults.toString();
        this.children = data.itinerary.pax.children.toString();
        this.infants = data.itinerary.pax.infants.toString();
        this.agentId = data.itinerary.agent.id.toString();
        this.agentName = data.itinerary.agent.name.toString();
        this.isLocked = data.itinerary.isLocked;
        this.createdAt = data.itinerary.createdAt;
        this.$store.dispatch("setItineraryAgent", data.itinerary.agent.id);
        this.$store.dispatch(
          "setItineraryAgentDepartment",
          data.itinerary.agent.department
        );

        this.$store.dispatch(
          "setItineraryAgentCurrency",
          data.itinerary.agent.financeSettings.currencyCode
        );
        this.bookedById = data.itinerary.bookedBy.id;
        this.bookedByName = data.itinerary.bookedBy.name;
        this.department = data.itinerary.department;
        this.$store.dispatch("setItineraryDepartment", this.department);
        this.reference = data.itinerary.reference;
        this.bookingStatus = data.itinerary.bookingStatus;
        this.destination = Object.assign({}, data.itinerary.destination);
        this.internalReference = data.itinerary.internalReference;
        this.clientReference = data.itinerary.clientReference;
        this.internalStatus = data.itinerary.internalStatus;
        this.startDate = data.itinerary.startDate;
        this.endDate = data.itinerary.endDate;
        this.items = data.itinerary.items.edges.map(this.fromItineryItem);
        this.participants = data.itinerary.participants.edges.map(
          this.fromItineraryParticipant
        );

        this.notes = data.itinerary.notes;
        this.serviceGroups = data.itinerary.serviceGroups.edges.map(
          this.serviceGroupsMap
        );
        this.brand = data.itinerary.brand;
        this.leadSource = data.itinerary.leadSource;
        this.comps = data.itinerary.comps.edges
          ? data.itinerary.comps.edges.map(removeGQLTypename)
          : [];
        this.sourceItinerary = data.itinerary.sourceItinerary;
      }
    },
    serviceGroupsMap(sg) {
      return {
        id: sg.node.id,
        name: sg.node.name,
        description: sg.node.description,
        items: sg.node.items.edges.map(removeGQLTypename),
        participants: sg.node.participants.edges.map(removeGQLTypename),
      };
    },
    onTemplateAddCancel() {
      this.showTemplateSettingDialog = false;
      this.selectedTemplate = {};
    },
    onExpandDateTo($payload) {
      this.endDate = $payload;
    },
    onAddTemplate(payload) {
      // Transform items for closeouts check (local payload only)
      this.templateItemsToCheck = payload.map((item) => ({
        serviceId: item.serviceId,
        startDate: item.startDate,
        endDate: item.endDate,
        qty: item.qty,
        adults: item.adults,
        children: item.children,
        infants: item.infants,
      }));

      // Set parentId for linked items by matching parentUid to uid, then using parent's id
      // This must be done BEFORE adding items so that itemsWithExtras computed property can find the parent
      for (let item of payload) {
        if (item.parentUid) {
          // Find parent item by matching parentUid to uid
          const parentItem = payload.find((i) => i.uid === item.parentUid);
          if (parentItem) {
            item.parentId = parentItem.id;
          }
        }
      }

      // Add items to itinerary
      for (let item of payload) {
        item.orderNo = getItiItemOrder(this.headerProps)(this.items)(item);
        item.boardBasis = item.basis; //https://tracker.globetrack.ie/issues/6916
        this.items.push(item);
      }

      // Force Vue reactivity by reassigning the items array
      // This ensures itemsWithExtras computed property recalculates with the new parentId values
      this.items = [...this.items];

      this.showTemplateSettingDialog = false;
      this.selectedTemplate = {};
      if (this.fromIncrement) {
        this.updateToZeroPrices();
      }
      this.checkForApplicableComps();
      //recalculate to get prices
      this.addRecalcLog = false;
      this.priceCheck = false;
      this.recalculate();
    },
    onRemoveSelectedServices(payload) {
      const remove = payload.filter(
        (i) => !i.hasPurchaseInvoice && !i.isMandatory
      );
      this.items = this.items.filter(
        (item) => remove.map((i) => i.id).indexOf(item.id) == -1
      );
      if (this.fromIncrement) {
        this.updateToZeroPrices();
      }
    },
    onReorderSelectedServices(payload) {
      this.items = reorderServices(this.startDate)(this.items);
    },
    onCustomPriceToggle(payload) {
      this.items = toggleCustomPrices(this.items)(payload);
    },
    onZeroSelectedServices(payload) {
      this.items = setZeroSellPrices(this.items)(payload);
    },

    onUpdateStatus(payload) {
      this.items = updateItemsStatus(this.items)(payload);
    },
    onUpdateExchangeRates(payload) {
      //for log
      payload.username = this.$store.getters.userConfig.username;
      this.items = updateExchangeRates(this.items)(payload);
    },
    onMoveDays($payload) {
      const updated = [];
      let expand = false;
      for (const item of this.items) {
        const cp = { ...item, extras: item.extras.map((e) => ({ ...e })) };

        if ($payload.items.map((s) => s.id).indexOf(cp.id) > -1) {
          cp.startDate = moment(item.startDate)
            .add($payload.days, "days")
            .toISOString(true);
          cp.endDate = moment(cp.endDate)
            .add($payload.days, "days")
            .toISOString(true);
          if (
            moment(cp.startDate) < moment(this.startDate) ||
            moment(cp.endDate) > moment(this.endDate)
          ) {
            expand = true;
          }
          //if it has extras move all its extras
          if (cp.extras && cp.extras.length > 0) {
            for (const extra of cp.extras) {
              extra.startDate = moment(extra.startDate)
                .add($payload.days, "days")
                .toISOString(true);
              extra.endDate = moment(extra.endDate)
                .add($payload.days, "days")
                .toISOString(true);
            }
          }
        } else {
          //check extras
          if (cp.extras && cp.extras.length > 0) {
            for (const extra of cp.extras) {
              if (
                $payload.items.map((s) => s.extraId).indexOf(extra.id) > -1 &&
                $payload.items.map((s) => s.id).indexOf(cp.id) == -1
              ) {
                if (
                  moment(cp.startDate) <
                    moment(extra.startDate).add($payload.days, "days") ||
                  moment(cp.endDate) >
                    moment(extra.endDate).add($payload.days, "days")
                ) {
                  alert(
                    `Cannot set extra dates outside main service! (${cp.serviceName} - ${extra.name})`
                  );
                  return false;
                } else {
                  extra.startDate = moment(extra.startDate)
                    .add($payload.days, "days")
                    .toISOString(true);
                  extra.endDate = moment(extra.endDate)
                    .add($payload.days, "days")
                    .toISOString(true);
                }
              }
            }
          }
        }
        //treat as new
        // but only if it is not mandatory charge https://tracker.globetrack.ie/issues/9174
        if (cp.serviceType != "MANDATORY_CHARGES") {
          cp.id = randomize("Aa0", 32);
        }
        updated.push(cp);
      }
      if (expand) {
        this.showExpandDatesConfirmation = true;
        this.expandDatesCb = () => {
          for (const updatedItem of updated) {
            if (moment(updatedItem.startDate) < moment(this.startDate)) {
              this.startDate = updatedItem.startDate;
            }
            if (moment(updatedItem.endDate) > moment(this.endDate)) {
              this.endDate = updatedItem.endDate;
            }
          }
          this.items = [...updated];
          this.itineraryDurationIsValid(this.startDate, this.endDate);
        };
      } else {
        this.items = [...updated];
      }
      this.checkCurrentItemsForCloseouts();
    },
    itineraryDurationIsValid(startDate, endDate) {
      //http://tracker.globetrack.ie/issues/6334
      const start = moment(startDate).startOf("day");
      const end = moment(endDate).startOf("day");
      if (start.isValid() && end.isValid()) {
        if (end.diff(start, "days") > 42) {
          alert(
            "CAUTION! Your itinerary exceeds 42 days. Please check your itinerary dates."
          );
        }
      }
      return true;
    },
    onShowAdhocFromEdit(item) {
      //console.log("showAdhoc fromEdit: ", item);
      this.showAdhocStartDate = item.startDate;
      this.showAdhocEndDate = item.endDate;
      this.showAdhocSupplierName = item.supplierName;
      this.showAdhocSupplierType = item.serviceType;
      this.showAdhocSupplier = { id: item.supplierId };
      this.showAdhocService = { id: item.serviceId };
      this.adhocRefreshKey = randomize("Aa0", 32);
      this.showAdhocEditItem = item;
      this.showAdhoc = true;
    },
    showAdhocFromQuickAdd(payload) {
      const {
        supplierType,
        destinationId,
        supplierName,
        serviceName,
        supplier,
      } = payload;
      this.showAdhocSupplierType = supplierType;
      this.showAdhocDestinationId = destinationId;
      this.showAdhocSupplierName = supplierName;
      this.showAdhocSupplier = supplier;
      this.showAdhocServiceName = serviceName;

      this.adhocRefreshKey = randomize("Aa0", 32);
      this.showAdhoc = true;
    },
    onShowAdhocFromGroupedView(payload) {
      //console.log("showAdhoc fromGrouped: ", payload, this.startDate);
      if (payload.fieldName == "startDate") {
        this.showAdhocStartDate = payload.label;
      } else {
        const { destinationId, supplierName, serviceName, supplier } = payload;
        this.showAdhocSupplierType = payload.label;
        this.showAdhocDestinationId = destinationId;
        this.showAdhocSupplierName = supplierName;
        this.showAdhocSupplier = supplier;
        this.showAdhocServiceName = serviceName;
        if (payload.label == "ACTIVITY" || payload.label == "OTHER") {
          this.showAdhocStartDate = this.startDate;
          this.showAdhocEndDate = this.startDate;
        }
      }
      this.adhocRefreshKey = randomize("Aa0", 32);
      this.showAdhoc = true;
    },
    onShowTemplateFromGroupedView(group) {
      if (group.fieldName == "startDate") {
        this.showTemplateStartDate = group.label;
      }
      this.templateSettingsRefreshKey = randomize("Aa0", 32);
      this.showTemplateSettingDialog = true;
    },
    onServiceGroupsChange(payload) {
      this.serviceGroups = [...payload];
    },
    onNewStartDate(newStartDate) {
      const oldRange = { start: this.startDate, end: this.endDate };
      const newRange = updateRangeByNewStartDate(oldRange, newStartDate);
      const updatedItems = updateItemsWithNewDateRange({
        oldRange,
        newRange,
        items: this.items,
      });
      this.startDate = newRange.start;
      this.endDate = newRange.end;
      this.items = [...updatedItems];
      this.addLog("DATES_CH");
      this.recalculate();
      this.checkCurrentItemsForCloseouts();
    },
    onStartDateChange(payload) {
      this.addLog("DATES_CH");
    },
    onEndDateChange(payload) {
      this.addLog("DATES_CH");
    },
    onMoveIt(payload) {
      const offset =
        payload.direction == "backward"
          ? payload.noOfDays * -1
          : payload.noOfDays;
      const newStartDate = moment(this.startDate)
        .startOf("day")
        .add(offset, "days")
        .format("YYYY-MM-DD");
      this.onNewStartDate(newStartDate);
    },
    onDragAndDropChange(payload) {
      //console.log("drag and drop change", payload);
      if (payload.added) {
        //add new item
        const item = { ...payload.added.element };
        item.startDate = payload.date;
        this.onServiceSelect(item);
      } else if (payload.removed) {
        const removedItemIndex = this.items.findIndex(
          (item) => item.id == payload.removed.element.id
        );
        console.log("removed item index", removedItemIndex);
        if (removedItemIndex > -1) {
          this.items.splice(removedItemIndex, 1);
        }
      }
    },
    onSFRItemSelected({ item, params }) {
      this.sfrStateless = true;
      if (item.prices && item.prices.length > 0) {
        if (this.addServiceStartDate != "") {
          item.startDate = this.addServiceStartDate;
        }

        this.onServiceSelect(item);
      } else {
        this.showAdhocSupplierName = item.supplierName;
        this.showAdhocSupplierType = item.serviceType;
        this.showAdhocSupplier = { id: item.supplierId };
        this.showAdhocService = { id: item.serviceId };
        this.showAdhocDestinationId = params.destinationId;
        if (this.addServiceStartDate != "") {
          this.showAdhocStartDate = this.addServiceStartDate;
        }
        if (item.serviceType != "ACCOMMODATION") {
          if (this.showAdhocStartDate != "") {
            this.showAdhocEndDate = this.showAdhocStartDate;
          } else {
            this.showAdhocStartDate = this.startDate;
            this.showAdhocEndDate = this.startDate;
          }
        } else {
          this.showAdhocEndDate = this.endDate;
        }
        this.adhocRefreshKey = randomize("Aa0", 32);
        this.showAdhoc = true;
      }
    },
    pingItinerary() {
      const fingerprint = {
        userAgent: window.navigator.userAgent,
        tabId: window.sessionStorage.getItem("tabId"),
      };
      this.$apollo
        .mutate({
          mutation: PING_IT,
          variables: { id: this.id, fingerprint: JSON.stringify(fingerprint) },
          fetchPolicy: "no-cache",
        })
        .then(() => {
          this.pinger = setTimeout(() => {
            this.pingItinerary();
          }, this.pingInterval);
          //console.log("pinger", this.pinger);
        })
        .catch((err) => {
          console.log("ping err:", err);
          clearTimeout(this.pinger);
        });
    },
    setAppToolbarInfo() {
      const info = `Ref: ${
        this.itinerary.reference.split("/")[2]
      }, From: ${this.$options.filters.formatDate(this.startDate)}, Agent: ${
        this.agentName
      }, Client: ${this.clientName}, Destination: ${
        this.destination.name
      }, Status: ${this.internalStatus} (${this.bookingStatus})`;
      document.title = `${
        this.itinerary.reference.split("/")[2]
      } | Edit | VueTrip`;
      this.$store.dispatch("setAppToolbarInfo", info);
    },
  },

  watch: {
    startDate(newVal) {
      this.showTemplateStartDate = newVal;
    },
  },

  computed: {
    minAdults() {
      //lowest no of adults in all items
      if (this.items.length > 0) {
        return Math.min(...this.items.map((item) => item.adults));
      }
      return 0;
    },
    minChildren() {
      if (this.items.length > 0) {
        return Math.min(...this.items.map((item) => item.children));
      }
      return 0;
    },
    minInfants() {
      if (this.items.length > 0) {
        return Math.min(...this.items.map((item) => item.infants));
      }
      return 0;
    },
    parentReference() {
      return this.sourceItinerary
        ? this.sourceItinerary.reference.split("/")[2]
        : "";
    },
    allowRecalculate() {
      return !this.$store.getters.hasAccessTo(
        "itineraries:hide_recalculate_button"
      );
    },
    fromIncrement() {
      return this.items.find((item) => item.serviceName == "TO ZERO PRICES");
    },
    hasAccessToLock() {
      return this.$store.getters.hasAccessTo("itineraries:lock");
    },
    itiInput() {
      return this.getItiInput();
    },
    paxTitle() {
      return this.participants.length > 0
        ? `Pax List - Lead Passenger: ${this.participants[0].title} ${this.participants[0].name} ${this.participants[0].surname} - Total: ${this.participants.length}pax`
        : "Pax List";
    },
    clientName() {
      return this.participants.length > 0
        ? `${this.participants[0].title} ${this.participants[0].name} ${this.participants[0].surname}`
        : "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    showQuickAdd() {
      return this.$store.getters.localSettings("itBuilderShowQuickAdd");
    },
    maxParticipants() {
      return Number(this.adults) + Number(this.children) + Number(this.infants); //https://tracker.globetrack.ie/issues/6851
    },
    validateFirstStep() {
      return (
        this.destination &&
        this.agentId != "" &&
        // this.participants.length > 0 &&
        this.department != ""
      );
    },
    saveLabel: function () {
      return this.id == "" ? "Save" : "Save Changes";
    },
    duration: function () {
      let start = moment(this.startDate).startOf("day");
      let end = moment(this.endDate).startOf("day");
      if (start.isValid() && end.isValid()) {
        return end.diff(start, "days");
      }
      return 1;
    },
    itinearyLabel: function () {
      return `${this.reference} - ${this.destinationName}`;
    },
    headerProps() {
      return {
        id: this.id,
        agentId: this.agentId,
        startDate: this.startDate,
        endDate: this.endDate,
        createdAt: this.createdAt,
        destinationId: this.destination.id,
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        duration: this.duration,
        departmentName: this.department,
      };
    },
    closeoutsMsg() {
      const msg = [];
      if (
        this.checkForCloseouts &&
        this.checkForCloseouts.length > 0 &&
        this.checkForCloseouts.some((c) => c.hasCloseouts)
      ) {
        msg.push("Closeouts found for the following services:");
        for (const closeout of this.checkForCloseouts) {
          if (closeout.hasCloseouts) {
            msg.push(
              `${closeout.supplierName} - ${
                closeout.serviceName
              } - ${closeout.closeoutDates.join(", ")}`
            );
          }
        }
      }
      return msg.join("\n");
    },
  },

  apollo: {
    itinerary: {
      query: ITINERARY_RECORD_FOR_BUILDER,
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data }) {
        this.setupFromData(data);

        //store init state
        this.storeInitState();
        this.setAppToolbarInfo();

        const timeSinceLastEdit = data.itinerary.timeSinceLastEdit;
        const fingerprint =
          data.itinerary.editedByFingerprint.toString() != ""
            ? JSON.parse(data.itinerary.editedByFingerprint)
            : null;

        const userAgent = fingerprint ? fingerprint.userAgent : "";
        const editedByTabId = fingerprint ? fingerprint.tabId : "";
        const currentTabId = window.sessionStorage.getItem("tabId");
        const differentTab = editedByTabId != currentTabId;
        //console.log(timeSinceLastEdit, this.pingInterval / 1000, this.editMode);
        if (
          timeSinceLastEdit <= this.pingInterval / 1000 &&
          !this.editMode &&
          differentTab
        ) {
          alert(
            `Itinerary is currently being edited by: ${
              this.$store.getters.userConfig.username !=
              data.itinerary.editedByName
                ? data.itinerary.editedByName
                : "You, check your other open windows/tabs"
            }, (${userAgent})`
          );
          clearTimeout(this.pinger);
          this.$router.push("/itinerary/" + this.id + "/details");
        } else {
          //ping it first
          this.pingItinerary();
          this.editMode = true;
          this.skipItLoad = true;
          this.loading = false;
        }
      },
      skip() {
        return this.id == "" || this.skipItLoad;
      },
      fetchPolicy: "network-only",
    },
    checkForCloseouts: {
      query: CHECK_FOR_CLOSEOUTS,
      variables() {
        return {
          input: {
            items: this.templateItemsToCheck,
            agentId: this.agentId,
            bookingDate: moment().format("YYYY-MM-DD"),
          },
        };
      },
      skip() {
        return !this.templateItemsToCheck;
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        console.log("check for closeouts result", data);
        if (this.closeoutsMsg.trim().length > 0) {
          alert(this.closeoutsMsg);
        }
        // Clear the check after showing the alert
        this.templateItemsToCheck = null;
        if (this.checkForCloseoutsResultCallback) {
          this.checkForCloseoutsResultCallback(data.checkForCloseouts);
        }
      },
    },
  },

  mounted() {
    //set tabId

    this.skipItLoad = false;
    if (this.id == "") {
      this.storeInitState();
    }
    EventBus.$on("iti-items-refresh", () => {
      this.items = [...this.items];
    });
    EventBus.$on("add-iti-log", (log) => {
      console.log("adding log", log);
      this.logs.push({ ...log, itineraryId: this.id });
    });
    this.setDefaultDepartment();
  },
  beforeCreate() {
    //this.$store.dispatch("initLocalSettings");
    //clear all timeouts
    let id = window.setTimeout(function () {}, 0);
    while (id--) {
      window.clearTimeout(id); // will do nothing if no timeout with id is present
    }
    window.addEventListener("offline", () => {
      console.log("Network connection lost!");
      if (this.pingInterval) {
        clearTimeout(this.pinger);
      }
    });
    window.addEventListener("online", () => {
      console.log("Network connection restored!");
      if (this.pingInterval) {
        this.pingItinerary();
      }
    });
  },
  beforeDestroy() {
    // Clear Timer
    clearTimeout(this.pinger);
    this.$store.dispatch("setAppToolbarInfo", "");
    document.title = "VueTrip";
    if (this.editMode) {
      this.closeIt();
    }
  },
  unmounted() {
    clearTimeout(this.pinger);
    if (this.editMode) {
      this.closeIt();
    }
  },
};
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(to right top, teal, rgb(0, 196, 196));
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilder.vue